import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="filter-select"
export default class extends Controller<HTMLSelectElement> {
  static values = {
    frame: String,
    url: String
  }

  // declare element: HTMLSelectElement
  declare urlValue: string
  declare frameValue: string

  connect() {
    // No need to add event listeners as we're using data-action in the view
  }

  onChange() {
    // Update URL for main search
    const url = new URL(this.urlValue, document.baseURI)
    const currentParams = new URLSearchParams(window.location.search)
    
    // Keep the search query parameter if it exists
    const searchQuery = currentParams.get('q')
    if (searchQuery) {
      url.searchParams.set('q', searchQuery)
    }

    // Add the service offering id if selected
    if (this.element.value) {
      url.searchParams.set('filters[service_offering_id]', this.element.value)
    } else {
      url.searchParams.delete('filters[service_offering_id]')
    }

    // Update both in_progress and pending frames
    Turbo.visit(url.toString(), {
      frame: this.frameValue,
      action: 'advance'
    })
  }
} 